import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from 'srcReact/components/common2/Button'
import Modal from 'srcReact/components/common2/Modal'
import { redirectToPage } from 'srcReact/helpers/history'
import styles from './styles.module.scss'

function CloseAccForOrgManagerModal({ showModal, closeAccType, hideModal, isNative }) {
  const { t } = useTranslation()
  const handleContact = () => {
    window.scrollTo(0, 0)
    redirectToPage(`/0/support?close=1`, isNative)
  }
  return (
    <Modal
      isOpen={showModal}
      handleClose={hideModal}
      title={
        closeAccType === 'deactivate'
          ? t('account_settings.sidebar.deactivate_org_manager')
          : t('account_settings.sidebar.delete_org_manager')
      }>
      <Button
        customStyle={styles.btnContact}
        size='medium'
        text={t('account_settings.sidebar.contact_us')}
        handleClick={handleContact}
      />
    </Modal>
  )
}

export default CloseAccForOrgManagerModal
